export const getServerErrorMessage = (error: any, defaultMessage: string): string => {
  const serverErrorMessage = error?.response?.data?.message;
  return serverErrorMessage ?? defaultMessage;
};
